const $ = require('jquery');
const modal = require('./../../app/modal');

module.exports = {
  init() {
    $(document).on('click', '.discussionComment-edit', function (e) {
      e.preventDefault();
      const comment_id = $(this).data('commentId');
      const comment_text = $(this).data('commentText');
      if (typeof comment_id === 'undefined') {
        return;
      }
      const $composer = $('.discussionComment-composer.discussionComment-composer--edit');
      $composer.removeClass('is-hidden');

      const discussionPost = $('.discussionPost');
      discussionPost.find('.discussionComment-edit').removeClass('is-hidden');
      discussionPost.find('.discussionComment-cancelLink').addClass('is-hidden');
      $(this).addClass('is-hidden');

      $composer.find('input[name="parent"]').val(comment_id);
      if (typeof comment_text !== 'undefined') {
        $composer.find('textarea[name="comment"]').val(comment_text);
      }

      $composer.insertAfter($(this).closest('.discussionComment'));

      const $reply = $(this).parent().siblings('.discussionComment-reply');
      $reply.find('.discussionComment-replyLink').addClass('is-hidden');

      $(this).siblings('.discussionComment-cancelLink').removeClass('is-hidden');
    });

    $(document).on('click', '#discussionComment-editBox  button', (e) => {
      e.preventDefault();
      let msg = $('#discussionComment-editBox').parent().data('confirmMsg');
      if (typeof msg === 'undefined') {
        msg = '';
        $('#discussionComment-editBox').submit();
        return;
      }
      const callback = function (result) {
        if (result) {
          $('#discussionComment-editBox').submit();
        }
      };
      modal.confirm(msg, callback);
    });
  },
};
